"use client";

import type { ActionButtonProps } from "@/components/ActionButton";
import { TestimonialSection as TestimonialSectionComponent } from "@/components/TestimonialSection";
import type { ImageDetails } from "@/types";

type Props = {
	testimonial: {
		image: ImageDetails;
		quote: string;
		author: {
			name: string;
			title: string;
			company: string;
		};
	};
	actions?: ActionButtonProps[];
	sectionId?: string;
};

const TestimonialSection = ({ testimonial, sectionId }: Props) => {
	return (
		<TestimonialSectionComponent
			id={sectionId}
			image={testimonial.image}
			quote={testimonial.quote}
			author={testimonial.author}
		/>
	);
};

export default TestimonialSection;
